import React from 'react'
import { AccomodationCard, Hero, PlanningReverse, Rooms, Waiting, Welcome } from '../components'
import { aboutBg, apartmentHeroImage, linkIcon } from '../assets'
import { apartments } from '../constants'
import ApartmentHero from '../components/ApartmentHero'
import NewRooms from '../components/NewRooms'
import Amenities from '../components/Amenities'
import Ikeja from '../components/Ikeja'
import OgunHero from '../components/OgunHero'

const OgunApartmentPage = () => {

  const styles = {
    backgroundImage: `linear-gradient(#00000080, #00000080), url(${aboutBg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center center' 
  }


  return (
    <div>
      <OgunHero />
      {/* <Hero
        hText='OUR APARTMENT'
        pText="Nestled in the serene neighborhood of Ikeja GRA in Lagos, our luxury apartments offer a unique blend of modern sophistication and homely warmth. Whether you're here for business, leisure, or a long-term stay, WosAm provides an unparalleled living experience tailored to meet your every need."
        imagePicture={apartmentHeroImage}
      /> */}
      {/* <div style={styles} className="flex flex-col justify-center md:px-[100px] px-4 md:h-[450px] h-[350px] md:mx-10 md:pt-0 pt-12 text-white">
        <span className="font-bold font-barlow text-sm tracking-widest">WosAm LUXURY APARTMENT</span>
        <h1 className="md:text-3xl md:leading-[48px] font-trajan  text-2xl font-bold my-4 w-full">
          ROOM & SUITES
        </h1>
      </div>
      <Welcome /> */}
      <NewRooms location="OGUN" />

      
      <Ikeja location="OGUN" />


      <Amenities />
      {/* <Rooms /> */}
      {/* <div className="mb-[60px]">
        <h3 className="text-2xl font-bold mb-6">
          Our Apartments
        </h3>
        <div className="grid md:grid-cols-2 grid-cols-1 gap-10">
          {
            apartments.map(item => (
              <AccomodationCard 
                id={item.id}
                imagePicture={item.imagePicture}
                name={item.name}
                price={item.price}
                pageRoute={item.pageRoute}
                bText='See More'
              />
            ))
          }
        </div>
      </div> */}

      {/* <h3 className="md:text-2xl text-xl font-bold mb-4">Amenities</h3> */}
      {/* Amenities Component */}
      {/* <div className="border border-[#919191] w-full rounded-md p-[80px] flex justify-between mb-10">
        <div className="flex flex-col items-center">
          <div className="w-32 h-32 rounded-full flex justify-center items-center bg-[#EFEFEF] mb-4">
            <img src={linkIcon} alt="" />
          </div>
          <p>Airport Pick Up/Drop Off</p>
        </div>
        <div className="flex flex-col items-center">
          <div className="w-32 h-32 rounded-full flex justify-center items-center bg-[#EFEFEF] mb-4">
            <img src={linkIcon} alt="" />
          </div>
          <p>Gym</p>
        </div>
        <div className="flex flex-col items-center">
          <div className="w-32 h-32 rounded-full flex justify-center items-center bg-[#EFEFEF] mb-4">
            <img src={linkIcon} alt="" />
          </div>
          <p>Swimming Pool</p>
        </div>
        <div className="flex flex-col items-center">
          <div className="w-32 h-32 rounded-full flex justify-center items-center bg-[#EFEFEF] mb-4">
            <img src={linkIcon} alt="" />
          </div>
          <p>Breakfast</p>
        </div>
        <div className="flex flex-col items-center">
          <div className="w-32 h-32 rounded-full flex justify-center items-center bg-[#EFEFEF] mb-4">
            <img src={linkIcon} alt="" />
          </div>
          <p>Fully Equipped Kitchen</p>
        </div>
      </div> */}

      {/* <div className="grid grid-cols-2 gap-10 my-[60px]">
        <div className="md:p-10 p-4 bg-[#EFEFEF] rounded-xl">
          <div className="flex flex-col justify-center bg-white text-black md:px-10 px-4 py-10 rounded-xl">
            <h2 className="md:text-xl text-2xl font-bold">Airport Pick Up/Drop Off</h2>
            <p className="mt-4 mb-6 leading-relaxed">Start and end your journey stress-free with our reliable airport transfer service.</p>
          </div>
        </div>
        <div className=" md:p-10 p-4 bg-[#EFEFEF] rounded-xl">
          <div className="flex flex-col justify-center bg-white text-black md:px-10 px-4 py-10 rounded-xl">
            <h2 className="md:text-xl text-2xl font-bold">Gym</h2>
            <p className="mt-4 mb-6 leading-relaxed">Stay fit and healthy during your stay with access to our fully equipped gym.</p>
          </div>
        </div>
      </div> */}

      {/* <PlanningReverse /> */}
      {/* <Waiting /> */}
    </div>
  )
}

export default OgunApartmentPage